<script setup lang="ts">
const { column } = defineProps<{
  column: FooterColumn
}>()
</script>

<template>
  <FooterLegacyColumn :name="column.name">
    <ul class="flex flex-col gap-1">
      <li v-for="item in column.items" :key="item.name">
        <NuxtLink :to="item.path">
          {{ item.name }}
        </NuxtLink>
      </li>
    </ul>
  </FooterLegacyColumn>
</template>
